export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line' },
  { slug: 'action', name: '动作片', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'love', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'scifi', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'horror', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'drama', name: '剧情片', icon: 'ri-film-line' },
  { slug: 'anime', name: '动漫', icon: 'ri-bear-smile-line' },
  { slug: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { slug: 'variety', name: '综艺', icon: 'ri-tv-line' },
];

export const categoryNames: Record<string, string> = {
  all: '全部电影',
  action: '动作片',
  comedy: '喜剧片',
  love: '爱情片',
  scifi: '科幻片',
  horror: '恐怖片',
  drama: '剧情片',
  anime: '动漫',
  documentary: '纪录片',
  variety: '综艺',
};